import { InstanceTypeOf } from '@/type-utils';
import { errorFactory } from '@/utils/error-utils';

export const { ReviewsServiceError } = errorFactory('ReviewsServiceError');

/**
 * Error to use when a generic error occurs in the reviews service.
 */
export type ReviewsServiceError = InstanceTypeOf<typeof ReviewsServiceError>;
